// React import
import React, { useState, useEffect, useCallback, Fragment } from "react";
// Material import
import { styled } from "@mui/system";
import { 
    Drawer, Box, TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Divider 
} from "@mui/material";
// custom component import
import { useMsal } from "@azure/msal-react";
import cross from './../../../assets/images/refresh-cw 1.svg';
import Plus from "./../../../assets/images/Plus.svg";
import styles from "./prioritize.module.css";
import CustomButton from "Samarth Module/components/buttons/CustomButton";
import SingleSelectWithInput from "Samarth Module/components/dropdown/SingleSelectWithInput";
import SnackBarMessage from "Samarth Module/components/snackbar/snackbar";
import { getCbuDetails, getCbuWeekPlan, insertPrioritizationMatrix } from "Samarth Module/api/PrioritizationMatrixAPI";
export const StyledTableCell = styled(TableCell)((props) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        color: "#fff",
        textAlign: "center",
        padding: "2px",
        fontSize: "11px",
        fontWeight: 600,
        outline: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "11px",
        fontWeight: 400,
        padding: "2px",
        color: "#2B2B2B",
        border: "1px solid #DBDBDB !important",
        textAlign: "center",
        whiteSpace: "nowrap",
    }
}));
const infoTableColumns = [
    { label: "Format", key: "Format" },
    { label: "Basepack code, description", key: "Basepack" },
    { label: "CBU code, description", key: "CBU" }
];
const tableColumns = [
    { label: "Week no.", key: "Week no", inputType: "Label"},
    { label: "Site code", key: "Site code", inputType: "Dropdown"},
    { label: "Week plan", key: "Week plan", inputType: "Text" },
    { label: "Priority", key: "Priority", inputType: "Dropdown" }
];
const PrioritizeAddNewCBU = ({anchor, open, closeDrawer, filterSiteCode=[], afterAdd})=>{
    const { accounts } = useMsal();
    const activeAccount = accounts[0] || null;
    const [txtCBU, setTxtCBU] = useState('');
    const [isBtnLoading, setIsBtnLoading] = useState(false);
    const [isAddBtnLoading, setIsAddBtnLoading] = useState(false);
    const [infoData, setInfoData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [dropdownOptions, setDropdownOptions] = useState({Priority:['Prio 1', 'Prio 2', 'Prio 3'], "Site code" : []});
    const [snackBarObject, setSnackBarObject] = useState({
        snackbarOpen: false,
        message: "",
        type: "error",
    });
    
    
    const closeSnackbar = useCallback(() => {
        setSnackBarObject((prev) => ({ ...prev, snackbarOpen: false }));
    }, []);
    const getCBUDetails = useCallback(async () => {
        setIsBtnLoading(true);
        try {
            if(txtCBU.length === 0){
                setSnackBarObject({ snackbarOpen: true, message:'Please enter CBU code', type: "error" });
            } else {
                // API CALL
                const resData = await getCbuDetails({ cbu: txtCBU });
                if(filterSiteCode?.length === 0){
                    const resSiteCodeData = await getCbuWeekPlan();
                    setDropdownOptions(prevOptions => ({
                        ...prevOptions,
                        "Site code": resSiteCodeData?.data?.site_codes
                    }));
                }else{
                    setDropdownOptions(prevOptions => ({
                        ...prevOptions,
                        "Site code": filterSiteCode
                    }));
                }
                setInfoData(resData?.cbu_details);
                if(!resData?.cbu_details || resData?.cbu_details?.length === 0){
                    setSnackBarObject({ snackbarOpen: true, message:'No data found for the given CBU code', type: "error" });
                }
            }
        } catch (error) {
            setSnackBarObject({ snackbarOpen: true, message:error.message, type: "error" });
        } finally {
            setIsBtnLoading(false);
        }
    }, [txtCBU, filterSiteCode]);

    
    // create initial data Function
    const createInitialData = useCallback(() => {
        setTableData(prev => {
            const tempTableData = [...prev];
            tempTableData.push(
            { id:1, "Week no": "Week n+1", "Site code": "", "Week plan": "", Priority: "" },
            { id:2, "Week no": "Week n+2", "Site code": "", "Week plan": "", Priority: "" }
            );
            return tempTableData;
        });
    }, []);
    // call createInitialData function in useeffect for first time load.
    useEffect(() => {
        createInitialData();
    }, [createInitialData]);
    // Add more function call. and add more rows.
    const addRowHandler = useCallback(() => {
        createInitialData();
    }, [createInitialData]);  
    // table input field onchange function
    const onChangeHandler = useCallback((label, value, rid) => {
        setTableData(prev => 
            prev.map(item => 
                item.id === rid ? { ...item, [label]: value } : item
            )
        );
    }, []);
    const hasAllKeyValues = (obj)=>{
        return Object.values(obj).every(value => value !== "" && value !== null && value !== undefined);
    }
    const priortizationMatrixAdd = useCallback( async() => {  
        try{
            setIsAddBtnLoading(true)
            const validRows = tableData.filter(row => hasAllKeyValues(row)); 
            if(validRows.length === 0){
                setSnackBarObject({ 
                    snackbarOpen: true, 
                    message:'Please select CBU code, week plan and piority for a row.', 
                    type: "error" 
                });
            }else{
                // create payload for insert
                const tblDataWithCbu = validRows.map(({ id, ...rest }) => ({
                    ...rest,
                    "CBU code": txtCBU
                }));
                const payload = {
                    email: activeAccount.username,
                    addCbuData : tblDataWithCbu
                };
                // API call
                const resData = await insertPrioritizationMatrix(payload);
                  
                if(resData?.status === 'success'){
                    //Delete local storage data
                    const cachedData = JSON.parse(localStorage.getItem("filterData_Prioritization Matrix"));
                    const cbuCacheData = cachedData?.data?.filters?.["CBU"];
                    const result = cbuCacheData?.find(entry => entry.startsWith(`${txtCBU} :`));
                    if (!result) {
                        localStorage.removeItem("filterData_Prioritization Matrix");
                    }
                    afterAdd(); // After add fetch data
                    setTimeout(() => {
                        closeDrawer();
                    }, 1500);
                } 
                setSnackBarObject({ 
                    snackbarOpen: true, 
                    message: resData?.message, 
                    type: resData?.status 
                });             
            }
            
        } catch(error){
            setSnackBarObject({ 
                snackbarOpen: true, 
                message: error?.message, 
                type: "error" 
            });
        } finally{
            setIsAddBtnLoading(false);
        }        
    }, [tableData, activeAccount, txtCBU, afterAdd, closeDrawer]);
    return (
        <Fragment>
            <Drawer 
                anchor={anchor} 
                open={open}
                sx={{ '& .MuiDrawer-paper': { width: "650px" } }}
            >
                <Box className={styles.heading}>
                    <span>Add new CBU</span>
                    <img src={cross}  alt="Close drawer" onClick={closeDrawer} className={styles.cross}/>
                </Box>
                <Box className={styles.txtMsg}>
                    <span>Description of adding the CBU will be given later, format, basepack and CBU description will be fetched from backends</span>
                </Box>
                <Box className={styles.searchContainer}>
                    <input
                        className={styles.searchInput}
                        placeholder="Enter CBU Code"
                        value={txtCBU}
                        onChange={(e) => setTxtCBU(e.target.value.toUpperCase())}
                    />
                    <CustomButton label={isBtnLoading ? "Get details..." : "Get details"} type="mm-submit" onClick={getCBUDetails} disabled={isBtnLoading || isAddBtnLoading} />
                </Box>
                <Box className={styles.searchContainer}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    {infoTableColumns.map((column) => (
                                        <StyledTableCell
                                            key={column.key}
                                            sx={{ backgroundColor: "var(--primany-table-header-color)" }}
                                        >{column.label}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {infoData.length ? infoData.map((row, rowId) => (
                                    <TableRow key={rowId} sx={{height:"27px"}}>
                                        {infoTableColumns.map((col, colId) => (
                                            <StyledTableCell key={`${rowId}${colId}`}>{row[col.label]}</StyledTableCell>
                                        ))}
                                    </TableRow>
                                )) : (
                                    <TableRow sx={{height:"27px"}}>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                        <StyledTableCell></StyledTableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Box className={styles.addmoreDiv}>
                    <CustomButton icon={Plus} label="Add more" type="addCbu" onClick={addRowHandler} disabled={isBtnLoading || isAddBtnLoading}/>
                </Box>
                <Box className={styles.tablDiv}>
                    <TableContainer style={{height: "50vh"}}>
                        <Table size="small" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {tableColumns.map((column) => (
                                        <StyledTableCell
                                            key={column.key}
                                            sx={{ backgroundColor: "var(--primany-table-header-color)" }}
                                        >{column.label}</StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length > 0 && tableData.map((row, rowId) => (
                                    <TableRow key={rowId} sx={{height:"27px"}}>
                                        {tableColumns.map((col, colId) => (
                                            col.inputType === 'Text' ? (
                                                <StyledTableCell key={`${rowId}${colId}`}>
                                                    <input
                                                        type="text"
                                                        key={`input-${col.key}${rowId}`}
                                                        className={styles.tblInput}
                                                        value={row[col.key]}
                                                        placeholder={col.label}
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value;
                                                            if (/^\d*\.?\d*$/.test(numericValue)) {
                                                                onChangeHandler(col.label, numericValue, row.id);
                                                            }
                                                        }}
                                                    />
                                                </StyledTableCell>
                                            ) : col.inputType === 'Dropdown' ? (
                                                <StyledTableCell key={`${rowId}${colId}`}>
                                                    <SingleSelectWithInput
                                                        key={`select-${col.key}${rowId}`}
                                                        placeholder={'Select'}
                                                        value={row[col.key]}
                                                        style={{ width: '120px' }}
                                                        options={dropdownOptions[col.label] || []}
                                                        pageFrom={'Priortize matrix'}
                                                        label={col.label}
                                                        onChangeHandler={(label, value) => onChangeHandler(label, value, row.id)}
                                                    />
                                                </StyledTableCell>
                                            ) : (
                                                <StyledTableCell key={`${rowId}${colId}`}>{row[col.key]}</StyledTableCell>
                                            )
                                        ))}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
                <Box className={styles.dividerDiv}><Divider /></Box>            
                <Box className={styles.footerDiv}>
                    <CustomButton label="Cancel" type="priorityCancel" onClick={closeDrawer}  />
                    <CustomButton label={isAddBtnLoading ? "Adding..." : "Add"} type="priortizeSubmit" onClick={priortizationMatrixAdd} disabled={isBtnLoading || isAddBtnLoading} />
                </Box>
            </Drawer>
            {/* Alert message show */}
            {snackBarObject.snackbarOpen && (
                <SnackBarMessage
                    type={snackBarObject.type}
                    snackbarMessage={snackBarObject.message}
                    snackbarOpen={snackBarObject.snackbarOpen}
                    setSnackbarOpen={closeSnackbar}
                />
            )}
        </Fragment>
    );
}
export default PrioritizeAddNewCBU;